import { supabase } from '@/lib/supabase'

export async function fetchLeaderboardRankings({
  p_group_id = null,
  p_sport_id = null,
  p_tournament_id = null,
  p_division_id = null,
  p_year = null,
  p_limit = 50,
  p_offset = 0,
}) {
  const { data, error } = await supabase.rpc('get_leaderboard_rankings', {
    p_group_id,
    p_sport_id,
    p_tournament_id,
    p_division_id,
    p_year,
    p_limit,
    p_offset,
  })
  if (error) throw error
  return data
}

export async function fetchLeaderboardCount({
  p_group_id = null,
  p_sport_id = null,
  p_tournament_id = null,
  p_division_id = null,
  p_year = null,
}) {
  const { data, error } = await supabase.rpc('get_leaderboard_count', {
    p_group_id,
    p_sport_id,
    p_tournament_id,
    p_division_id,
    p_year,
  })
  if (error) throw error
  return Number(data) || 0
}

export async function fetchUserLeaderboardPage({
  p_group_id = null,
  p_sport_id = null,
  p_tournament_id = null,
  p_division_id = null,
  p_bracket_id = null,
  p_year = null,
  p_page_size = 50,
}) {
  const { data, error } = await supabase.rpc('get_user_leaderboard_page', {
    p_group_id,
    p_sport_id,
    p_tournament_id,
    p_division_id,
    p_bracket_id,
    p_year,
    p_page_size,
  })
  if (error) throw error
  return data || { rank: null, page_index: null }
}

export async function fetchUserGroups(userId) {
  const { data, error } = await supabase.rpc('get_groups', {
    p_user_id: userId,
  })
  if (error) throw error
  return data
}

export async function fetchActiveSports() {
  const { data, error } = await supabase
    .from('sports')
    .select('id, name')
    .eq('is_active', true)
    .order('name')
  if (error) throw error
  return data
}

export async function fetchTournamentsBySport(sportId) {
  const { data, error } = await supabase
    .from('tournaments')
    .select('id, name')
    .eq('sport_id', sportId)
    .eq('is_test', false)
    .order('name')
  if (error) throw error
  return data
}

export async function fetchDivisionsBySport(sportId) {
  const { data, error } = await supabase
    .from('divisions')
    .select('id, name')
    .eq('sport_id', sportId)
    .eq('is_active', true)
    .order('name')
  if (error) throw error
  return data
}
